import { requestConfig, requestM365 } from './api';
import { AUTH, REST_METHOD, REST_URL, LANGUAGE, CONFIG } from './../constants';
import { CONFIG_CLIENT } from 'constants/configClientConstant';
import store from 'redux/store';
import { checkValidURL } from 'utils/function';

interface CheckUserIsInGroupParams {
  userEmail: string;
  groupName: string;
};

const AppService = {
  getValueConfigAzure: async (key: string, label: string) => {
    const client = localStorage.getItem(CONFIG_CLIENT.CLIENT_STORAGE) || "";
    let clientUrl = client === CONFIG_CLIENT.DEFAULT ? "" : `/${client}`;
    try {
      const requestParams = {
        url: `${REST_URL.CONFIGURATIONS}${clientUrl}/${key}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { label },
      };
      let result = await requestConfig(requestParams);
      return result ? result.data.value : null;
    } catch (error) {
      console.log("ERROR FROM APP_CONFIG:", error)
    }
  },

  getListConfigAzure: async (label: string) => {
    const client = localStorage.getItem(CONFIG_CLIENT.CLIENT_STORAGE) || "";
    let clientUrl = client === CONFIG_CLIENT.DEFAULT ? "" : `/${client}`;
    try {
      const requestParams = {
        url: `${REST_URL.CONFIGURATIONS}${clientUrl}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { label },
      };
      let result = await requestConfig(requestParams);
      return result ? result.data : null;
    } catch (error) {
      console.log("ERROR FROM APP_CONFIG:", error)
    }
  },

  getKBNumber: (config: any, name: string, language: string) => {
    if(config) {
      const configType = name;
      const getKBTopList = (kbData: any[], languageCode : string = 'en') => {
        return kbData.map(kb => kb[languageCode]).filter(Boolean);
      }

      switch(configType)  {
        case CONFIG.KNOWLEDGE.KB_TOP: {
          const configData = config[CONFIG.KNOWLEDGE.KB_TOP] ?? null;
          return configData ? getKBTopList(config[CONFIG.KNOWLEDGE.KB_TOP], language) : [];
        }
        default:
          return config[name][language] || config[name][LANGUAGE.DEFAULT];
      }
    } else {
      return null;
    }
  },

  getMyOfficeLinks: async (userEmail: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.M365}${REST_URL.GET_MY_OFFICE_LINKS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { user_email: userEmail },
      };
      const response = await requestM365(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getMyOwnMsTeams: async (userEmail: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.M365}${REST_URL.GET_MY_OWN_TEAMS}`,
        method: `${REST_METHOD.GET}`,
        queryParams: { user_email: userEmail },
      };
      const response = await requestM365(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  checkUserIsInGroup: async (params: CheckUserIsInGroupParams) => {
    try {
      const requestParams = {
        url: `${REST_URL.M365}${REST_URL.CHECK_USER_IS_IN_GROUP}`,
        method: `${REST_METHOD.POST}`,
        data: params,
      }
      const response = await requestM365(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getEnvConfig: async () => {
    try {
      const result = await fetch(window.location.origin + '/env.json');
      return await result.json();
    } catch (error) {
      return null;
    }
  },

  getJsonConfig: async (jsonName: string) => {
    const jsonConfigSuffix = store.getState()?.configReducer?.generalConfig
      ?.uptimeApimServices?.jsonConfigSuffix;
    try {
      const isLocal =
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';
      const path = isLocal ? REST_URL.UI_CONFIGUTATION : jsonConfigSuffix;
      const result = !path
        ? null
        : await fetch(
            checkValidURL(path)
              ? `${path}/${jsonName}.json`
              : window.location.origin + `${path}/${jsonName}.json`,
          );
      return (await result?.json()) || null;
    } catch (error) {
      return null;
    }
  },

  getRouteJsonConfig: async () => {
    const jsonConfigSuffix =
      store.getState()?.configReducer?.generalConfig?.uptimeApimServices
        ?.jsonConfigSuffix ?? REST_URL.CDN + REST_URL.UI_CONFIG;
    try {
      const isLocal =
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';
      const path = isLocal ? REST_URL.UI_CONFIGUTATION : jsonConfigSuffix;
      const result = await fetch(
        checkValidURL(path)
          ? `${path}/routes.json`
          : window.location.origin + `${path}/routes.json`,
      );
      return await result.json();
    } catch (error) {
      return null;
    }
  },

  getPCLConfig: async (jsonName: string) => {
    try {
      const result = await fetch(window.location.origin + `/configuration/pc_licycle/${jsonName}.json`);
      return await result.json();
    } catch (error) {
      return null;
    }
  },

  isAuthenticatedByAzure: () => sessionStorage.getItem(AUTH.AUTH_BY)?.toUpperCase() === AUTH.AZURE,
  isAuthenticatedByOidc: () => sessionStorage.getItem(AUTH.AUTH_BY)?.toUpperCase() === AUTH.OIDC
};

export default AppService;
